<div class="custom-container">
  <h1>403 - Session expired or access denied</h1>
  <p class="forbidden-message">
    Your session may be outdated or you do not have permission to view this page.
    Please sign in again to continue.
  </p>

  @if (userName || userEmail || userRole) {
    <div class="user-card">
      <p class="user-card-title">Currently signed in as</p>
      @if (userName) {
        <p class="user-name">{{ userName }}</p>
      }
      @if (userEmail) {
        <p class="user-email">{{ userEmail }}</p>
      }
      @if (userRole) {
        <p class="user-role">Role: {{ userRole }}</p>
      }
    </div>
  }

  <button mat-raised-button color="primary" class="login-btn" (click)="login()">
    Log in again
  </button>
</div>
